import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import faqData from '../../data/faq.json';

type FAQItem = { q: string; a: string };
type FAQData = Record<string, Array<FAQItem>>;

const data = faqData as FAQData;

const normalizeRoute = (p: string): string => {
  const c = String(p).replace(/\/{2,}/g, '/').replace(/^\/+/, '').replace(/\/+$/, '');
  return c ? '/' + c : '/';
};

export default function FAQSection() {
  const { pathname } = useLocation();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const items = data[normalizeRoute(pathname)];
  const isRelated = pathname === '/related' || pathname.startsWith('/related/') || pathname === '/en/related' || pathname.startsWith('/en/related/');

  if (!items || items.length === 0) {
    return null;
  }

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section className="py-16 md:py-20 bg-[#faf8f5]">
      <div className="max-w-6xl mx-auto px-5 sm:px-6 lg:px-8 md:px-8">
        <h2 className="text-2xl md:text-3xl font-medium text-center mb-10" style={{ fontFamily: '"Noto Serif JP", serif' }}>
          {pathname === '/en' || pathname.startsWith('/en/') ? 'Frequently Asked Questions' : 'よくあるご質問'}
        </h2>
        <div className="space-y-4">
          {items.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.q}
                className="bg-white border border-gray-200 rounded-lg"
              >
                <button
                  type="button"
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
                  onClick={() => toggle(index)}
                  aria-expanded={isOpen}
                  aria-controls={`faq-panel-${index}`}
                >
                  {isRelated ? <h3 className="font-medium">{item.q}</h3> : <span className="font-medium">{item.q}</span>}
                  <i
                    className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'} text-amber-600 text-xl flex-shrink-0`}
                    aria-hidden="true"
                  />
                </button>
                {isOpen && (
                  <div id={`faq-panel-${index}`} className="px-5 pb-5 text-gray-600 leading-relaxed">
                    {item.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
